/**
 * Determines if negative space tool should be shown based on the ab_design_lab_negative_space_tool experiment
 * Variant 1 (10%) shows the tool, variants 0,2-9 (90%) is control
 * @param experimentValue - The experiment variant value (0-9, where only 1 shows the feature)
 * @returns true if negative space tool should be shown, false if it should be hidden
 */
export function shouldShowNegativeSpaceTool(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}

/**
 * Determines if design lab tabs should be reordered based on the ab_design_lab_reorder_tabs experiment
 * Variant 1 (candidate) shows the new order: Upload -> Design -> Products -> Sizes
 * Variant 0 (control) shows the original order: Upload -> Products -> Sizes -> Front -> Back
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if tabs should be reordered, false if original order should be used
 */
export function shouldReorderDesignLabTabs(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}

/**
 * Determines if pin-based redraw should be enabled based on the ab_pin_based_redraw_notes experiment
 * The backend fully gates this feature - it returns true only if:
 * - User has role override, OR
 * - Experiment flip is enabled AND user is variant 1
 *
 * This function just uses the backend-computed value for consistency.
 * @param _experimentValue - The experiment variant value (unused, backend handles gating)
 * @param flipEnabled - The boolean flag from backend (backend fully gates the feature)
 * @returns true if pin-based redraw should be enabled, false if old UI should be shown
 */
export function shouldEnablePinBasedRedraw(
  _experimentValue: number | undefined,
  flipEnabled: boolean
): boolean {
  // Backend fully gates the feature - just use the backend value
  // Backend returns true only if: role override OR (experiment flip enabled AND variant 1)
  return flipEnabled;
}
